import type z from "zod";

import { optionSchema } from "@/schemas/option";
import { credentialGradeIdSchema } from "@/types/credentialGrade";

export const CredentialGradeOptionSchema = optionSchema(
  credentialGradeIdSchema,
);
export type CredentialGradeOption = z.infer<typeof CredentialGradeOptionSchema>;
